import Cookies from 'js-cookie';

export const accessKey = 'accessKey';

const AccessKey = {
  get: (): string => Cookies.get(accessKey) as string,
  set: (key: string) => Cookies.set(accessKey, key),
  remove: () => Cookies.remove(accessKey)
};


export const isLogin = () => {
  const accessKey = AccessKey.get();
  if (accessKey === 'undefined') return false;
  if (typeof accessKey === 'undefined') return false;
  return !!accessKey;

};

export default AccessKey;
